<button class="c-button" (click)="navigateToSearch()">
  <i class="fas fa-search m-r-base"></i>
  <span>{{'search' | cbsLabel}}</span>
</button>
